/**
 * Properly rounds a number to totalDecimals specified
 * @param {Number} number - Full url path to replace the parameters
 * @param {Int} totalDecimals - Number
 * @return {Number} path - Path with replaced parameters
 */
export function round(number, totalDecimals) {
  return Number(number.toFixed(totalDecimals));
}
